import * as React from 'react';

const InlineChevronIcon = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='0.9em'
    height='0.9em'
    viewBox='6 6 12 12'
    fill='none'
    style={{ transform: 'translateY(0.1em)', marginLeft: '0.3em' }}
    {...props}
  >
    <path
      d='M10.008 6 8.6 7.41 13.174 12 8.6 16.59 10.008 18 16 12Z'
      stroke={'none'}
      fill={'currentColor'}
    />
  </svg>
);

export default InlineChevronIcon;
